<template>
  <div v-if="$userInfo">
    <app-detail-header :show-toggle="true"
      :show-delete="false"
      :show-save="false"
      :show-cancel="false"
      :show-new="false"
      :show-print="false"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked" />
    <div>
      <error-log-list />
    </div>
  </div>
</template>

<script>
import AppDetailHeader from '../../components/AppDetailHeader/AppDetailHeader.vue'
import ErrorLogList from './ErrorLogList.vue'
import { AppHeaderButtonTypes } from '@/enums'

export default {
  name: 'ErrorLogListView',
  components: { ErrorLogList, AppDetailHeader },
  props: {
    value: null
  },
  data: () => {
    return {
      id: '',
      entities: {},
      isModelActive: false
    }
  },
  watch: {

  },
  created() {

  },
  mounted() {},
  methods: {
    onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.ToggleSide:
          this.toggleSide()
          break
      }
    },
    toggleSide() {
      // Handle toggle side menu
    }

  }
}
</script>
